import {yupResolver} from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';
import {Button, Grid} from '@mui/material';
import React, {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import QRCode from 'react-qr-code';
import config from 'src/config';
import {i18n} from 'src/i18n';
import servicioEnumerators from 'src/modules/servicio/servicioEnumerators';
import yupFormSchemas from 'src/modules/shared/yup/yupFormSchemas';
import InputFormItem from 'src/view/shared/form/items/InputFormItem';
import InputNumberFormItem from 'src/view/shared/form/items/InputNumberFormItem';
import SelectFormItem from 'src/view/shared/form/items/SelectFormItem';
import TextAreaFormItem from 'src/view/shared/form/items/TextAreaFormItem';
import FormWrapper, {FormButtons} from 'src/view/shared/styles/FormWrapper';
import TipoServicioAutocompleteFormItem from 'src/view/tipoServicio/autocomplete/TipoServicioAutocompleteFormItem';
import * as yup from 'yup';

const schema = yup.object().shape({
  descripcion: yupFormSchemas.string(i18n('entities.servicio.fields.descripcion'), {
    required: true,
  }),
  tipoServicio: yupFormSchemas.relationToOne(i18n('entities.servicio.fields.tipoServicio'), {
    required: true,
  }),
  centrosCostos: yupFormSchemas.relationToMany(i18n('entities.servicio.fields.centrosCostos'), {}),
  costoHora: yupFormSchemas.integer(i18n('entities.servicio.fields.costoHora'), {}),
  detalles: yupFormSchemas.string(i18n('entities.servicio.fields.detalles'), {}),
  cadaFrecuencia: yupFormSchemas.integer(i18n('entities.servicio.fields.cadaFrecuencia'), {}),
  frecuencia: yupFormSchemas.enumerator(i18n('entities.servicio.fields.frecuencia'), {
    options: servicioEnumerators.frecuencia,
  }),
  tercerosVinculados: yupFormSchemas.relationToMany(i18n('entities.servicio.fields.tercerosVinculados'), {}),
});

function ServicioForm(props) {
  const [initialValues] = useState(() => {
    const record = props.record || {};

    return {
      descripcion: record.descripcion,
      tipoServicio: record.tipoServicio,
      centrosCostos: record.centrosCostos || [],
      costoHora: record.costoHora,
      detalles: record.detalles,
      cadaFrecuencia: record.cadaFrecuencia,
      frecuencia: record.frecuencia,
      tercerosVinculados: record.tercerosVinculados || [],
    };
  });

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: initialValues as any,
    shouldUnregister: false,
  });

  const onSubmit = (values) => {
    props.onSubmit(props.record?.id, values);
  };

  const onReset = () => {
    Object.keys(initialValues).forEach((key) => {
      form.setValue(key, initialValues[key]);
    });
  };

  const {saveLoading, modal} = props;

  return (
    <FormWrapper>
      <FormProvider {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto',
            paddingBottom: '16px',
          }}>
          <Grid spacing={2} container>
            <Grid item lg={props.drawer ? 12 : 7} md={8} sm={12} xs={12}>
              <h1>{form.watch('descripcion')}</h1>

              <div style={{marginBottom: 15}}>
                <QRCode
                  value={`${config.frontendUrl.protocol}://${config.frontendUrl.host}/servicio/${props.record?.id}`}
                  size={140}
                />
              </div>
            </Grid>
            <Grid item lg={props.drawer ? 12 : 7} md={8} sm={12} xs={12}>
              <InputFormItem
                name="descripcion"
                disabled={props.disabled}
                label={i18n('entities.servicio.fields.descripcion')}
                required={true}
                autoFocus
              />
            </Grid>
            <Grid item lg={props.drawer ? 12 : 7} md={8} sm={12} xs={12}>
              <TipoServicioAutocompleteFormItem
                name="tipoServicio"
                disabled={props.disabled}
                label={i18n('entities.servicio.fields.tipoServicio')}
                required={true}
                showCreate={!props.modal}
              />
            </Grid>
            {/* <Grid item lg={props.drawer?12:7} md={8} sm={12} xs={12}>
              <CentroCostoAutocompleteFormItem
                name="centrosCostos"
                disabled={props.disabled}
                label={i18n(
                  'entities.servicio.fields.centrosCostos',
                )}
                required={false}
                showCreate={!props.modal}
                mode="multiple"
              />
            </Grid> */}
            <Grid item lg={props.drawer ? 12 : 7} md={8} sm={12} xs={12}>
              <InputNumberFormItem
                name="costoHora"
                disabled={props.disabled}
                label={i18n('entities.servicio.fields.costoHora')}
                required={false}
              />
            </Grid>
            <Grid item lg={props.drawer ? 12 : 7} md={8} sm={12} xs={12}>
              <TextAreaFormItem
                name="detalles"
                disabled={props.disabled}
                label={i18n('entities.servicio.fields.detalles')}
                required={false}
              />
            </Grid>

            <Grid item lg={12} md={8} sm={12} xs={12}>
              <h2>Frecuencia con la que se utiliza este servicio</h2>
            </Grid>

            <Grid item lg={3} md={8} sm={12} xs={12}>
              <InputNumberFormItem
                name="cadaFrecuencia"
                disabled={props.disabled}
                label={i18n('entities.servicio.fields.cadaFrecuencia')}
                required={false}
              />
            </Grid>
            <Grid item lg={4} md={8} sm={12} xs={12}>
              <SelectFormItem
                name="frecuencia"
                disabled={props.disabled}
                label={i18n('entities.servicio.fields.frecuencia')}
                options={servicioEnumerators.frecuencia.map((value) => ({
                  value,
                  label: i18n(`entities.servicio.enumerators.frecuencia.${value}`),
                }))}
                required={false}
              />
            </Grid>
            {/* <Grid item lg={props.drawer?12:7} md={8} sm={12} xs={12}>
              <TerceroAutocompleteFormItem  
                name="tercerosVinculados"
                disabled={props.disabled}
                label={i18n('entities.servicio.fields.tercerosVinculados')}
                required={false}
                showCreate={!props.modal}
                mode="multiple"
              />
            </Grid> */}
          </Grid>
        </form>
        {!props.disabled && (
          <FormButtons
            style={{
              flexDirection: modal ? 'row-reverse' : undefined,
            }}>
            <Button
              variant="contained"
              color="primary"
              disabled={saveLoading}
              type="button"
              onClick={form.handleSubmit(onSubmit)}
              startIcon={<SaveIcon />}
              size="small">
              {i18n('common.save')}
            </Button>

            <Button disabled={saveLoading} onClick={onReset} type="button" startIcon={<UndoIcon />} size="small">
              {i18n('common.reset')}
            </Button>

            {props.onCancel ? (
              <Button
                disabled={saveLoading}
                onClick={() => props.onCancel()}
                type="button"
                startIcon={<CloseIcon />}
                size="small">
                {i18n('common.cancel')}
              </Button>
            ) : null}
          </FormButtons>
        )}
      </FormProvider>
    </FormWrapper>
  );
}

export default ServicioForm;
